export type LanguageOption = {
    code: string;
    label: string;
};

export const fallbackLng = 'en'

export const languageOptions: LanguageOption[] = [
    { code: 'en', label: 'ENGLISH (OV)' },
    { code: 'fr', label: 'FRAN\u00c7AIS' },
    { code: 'es', label: 'ESPA\u00d1OL' },
    { code: 'pt-BR', label: 'PORTUGU\u00caS (BRASIL)' },
];

export const languages = languageOptions.map(l => l.code)
export const defaultNS = 'translation'
export const LANGUAGE_QUERY_PARAM = 'lng'
export const COOKIE_NAME = 'i18next'
export function getOptions (lng = fallbackLng, ns: string | undefined = defaultNS) {
    return {
        // debug: true,
        supportedLngs: languages,
        fallbackLng,
        lng,
        fallbackNS: defaultNS,
        defaultNS,
        ns,
        // Required for runtime language switching when using resourcesToBackend with initial resources
        partialBundledLanguages: true
    }
}
